/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import List from 'can/list/list';
import 'can/list/sort/sort';
import 'can/construct/super/super';

const ascOrdering = 0;
const descOrdering = 1;
const pinTop = 0;
const pinBottom = 1;
const firstPosition = -1;
const lastPosition = 1;
const samePosition = 0;

export default List.extend({
    ascOrdering,
    descOrdering,
    pinTop,
    pinBottom,

    invertOrdering: function (ordering) {
        return ordering === 1 ? -1 : 1;
    },

    /**
     * Sorts objects using properties. Sorting supports pinning. Particular values can be at the top or at the bottom
     * regardless sorting of other properties.
     *
     * @param ordering
     * @param properties
     */
    getPropertiesSorter: function (ordering, properties = {}) {
        return (a, b) => {
            let result = undefined;

            for (let {property, pinnedValue = undefined, pin = pinTop, stopOnNotSame = false} of properties) {
                const value1 = _.get(a, property);
                const value2 = _.get(b, property);

                if (pinnedValue !== undefined) {
                    if (value1 === pinnedValue && value2 !== pinnedValue) {
                        result = lastPosition;
                    }
                    else if (value1 !== pinnedValue && value2 === pinnedValue) {
                        result = firstPosition;
                    }

                    if (result !== undefined && result !== samePosition) {
                        if (pin === pinBottom) {
                            result = result === lastPosition ? lastPosition : firstPosition;
                        }

                        return result;
                    }
                }
                else {
                    result = value1 > value2 ? lastPosition : (value1 < value2 ? firstPosition : samePosition);

                    if (ordering === descOrdering && result !== samePosition) {
                        result = this.invertOrdering(result);
                    }

                    if (stopOnNotSame && result !== samePosition) {
                        break;
                    }
                }
            }

            return result === undefined ? samePosition : result;
        }
    }
}, {
    pushAll: function (items) {
        return this.push.apply(this, items);
    },
    unshiftAll: function (items) {
        return this.unshift.apply(this, items);
    },
    getItemByField: function (value, field) {
        field = field || 'id';
        for (var i = 0, ii = this.length; i < ii; i++) {
            var item = this[i];
            if (item[field] === value) {
                return item;
            }
        }
        return null;
    },
    getItemIndexByField: function (value, field) {
        field = field || 'id';
        for (var i = 0, ii = this.length; i < ii; i++) {
            var item = this[i];
            if (item[field] === value) {
                return i;
            }
        }
        return null;
    },
    toArray: function () {
        var arr = [];
        for (var i = 0, ii = this.length; i < ii; i++) {
            arr.push(this[i]);
        }
        return arr;
    }
});
